const getDefaultState = () => {
  return {
    products: [],
    product: {},
    totalItems: null,
    totalPage: null,
    operators: [
      {
        code: null,
        price: null,
        mobile_network_uuid: null,
      },
    ],
    operator: {},
    activeOperatorId: 0,
    activeNetworkName: null, // ??
    allMobileNetworks: [],
    allVendors: [
      [
        {
          vendor_product_uuid: null,
          mobile_network_uuid: null,
        },
      ],
    ],
    networkName: null,
    loading: true,
  };
};

const state = getDefaultState();

export { state, getDefaultState };
